<script setup>
import { ref, reactive } from 'vue';
import TabNavigator from '@/Shared/Navigation/TabNavigator';

let props = defineProps({
    data: Object,
});

let tabNavigation = [
    { name: 'About', href: route('company.about'), current: false },
    { name: 'Team', href: route('company.team'), current: false },
    { name: 'Partners', href: route('company.partners'), current: false },
    { name: 'Legal', href: route('company.legal'), current: true },
];
</script>

<template>
    <div class="relative w-full">
        <TabNavigator :tabs="tabNavigation" />
        <h2
            class="mt-12 px-2 text-center text-3xl font-bold text-white sm:mt-16"
        >
            Legal
        </h2>
        <div class="relative mt-12 mb-40 sm:mt-16">
            <div class="flex grid-cols-12 flex-col sm:grid">
                <div class="col-span-8 col-start-3 col-end-11">
                    <ul
                        class="mx-5 list-disc text-white md:list-none md:text-center"
                    >
                        <li v-for="link in data.content" class="mb-1">
                            <a
                                :href="link.link"
                                class="border-b border-transparent text-center text-white hover:border-white"
                            >
                                {{ link.text }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
